export default __webpack_public_path__ + "static/media/icon_doublechevron_right.26e7e3c9.svg";